import { useState, useEffect } from 'react';
import { api } from '../api/client';

const NODES_V1 = [
  { role: 'gateway_router',   name: 'Gateway Router',   icon: '⬡', desc: 'Phân luồng Intent & TTFT < 150ms (Gemini 2.5 Flash Lite)' },
  { role: 'lane_0_agent',     name: 'Reception Agent',  icon: '🛎️', desc: 'Giao tiếp thông thường & Tán gẫu (Gemini 2.5 Flash Lite)' },
  { role: 'the_brain',        name: 'The Brain',        icon: '🧠', desc: 'Lập luận 5 trục & Quyền riêng tư Edge (DeepSeek-V4-Pro-0813)' },
  { role: 'empathy_smoother', name: 'Empathy Smoother', icon: '💖', desc: 'Cảm xúc & Văn phong tiếng Việt (Gemini 2.5 Flash · On-Demand)' },
  { role: 'embedder',         name: 'Embedder',         icon: '🗂️', desc: 'Vector embeddings cho RAG (BAAI bge-m3)' },
  // Micro-Agents Swarm
  { role: 'node_llama_illusionist',     name: 'Illusionist',      icon: '🎭', desc: 'Tạo ảo giác chờ đợi UX (Gemini 2.5 Flash Lite)' },
  { role: 'node_llama_noise_filter',    name: 'Noise Filter',     icon: '🧹', desc: 'Nén Text & Lọc rác Web Scraped (Gemini 2.5 Flash Lite)' },
  { role: 'node_llama_history_trimmer', name: 'History Trimmer',  icon: '✂️', desc: 'Nén Token vòng lặp ReAct trên Edge (DeepSeek-V4-Flash-0731)' },
  { role: 'node_llama_empathy_smoother',name: 'Empathy Smoother (V2)', icon: '🫂', desc: 'Làm mượt văn phong báo cáo (Gemini 2.5 Flash)' },
  { role: 'node_r1_core_reasoner',      name: 'Core Reasoner',    icon: '⚙️', desc: 'Tạo Blueprint Logic & Payload (DeepSeek-V4-Pro-0813)' },
  { role: 'node_r1_mindmapper',         name: 'Mindmapper',       icon: '🗺️', desc: 'Lập dàn ý Deep Research siêu tốc (DeepSeek-V4-Flash-0731)' },
  { role: 'node_r1_editor_in_chief',    name: 'Editor In Chief',  icon: '📰', desc: 'Tổng biên tập báo cáo khổng lồ (GPT-OSS-120B · $0.70/M)' },
];

const NODES_V2 = [
  // Swarm V2 Nodes
  { role: 'v2_receptionist', name: 'V2 Receptionist', icon: '💁', desc: 'Swarm V2 Lễ Tân (Gemini 2.5 Flash Lite)' },
  { role: 'v2_ceo',          name: 'V2 CEO',          icon: '👔', desc: 'Swarm V2 Giám Đốc Phân loại & Lập KH (DeepSeek-V4-Pro-0813)' },
  { role: 'v2_expert',       name: 'V2 Expert',       icon: '🎓', desc: 'Swarm V2 Chuyên Gia Cấp Cao (DeepSeek-V4-Pro-0813)' },
  { role: 'v2_worker',       name: 'V2 Worker',       icon: '🐝', desc: 'Swarm V2 Kiến Thợ thực thi tool (DeepSeek-V4-Flash-0731)' },
];

const NODES_IMAGE = [
  { role: 'text_to_image', name: 'Image Generator', icon: '🎨', desc: 'Sinh ảnh từ Text (Erix Image · Cloudflare AI · R2 Storage) — Lane 3 ✅' },
  { role: 'image_to_text', name: 'Vision Node',     icon: '👁️', desc: 'OCR tài liệu, hóa đơn & đọc ảnh (Gemini 2.5 Flash)' },
];

const ALL_NODES = [...NODES_V1, ...NODES_V2, ...NODES_IMAGE];

// All providers that need API key input in the UI
// Key = provider name used in chainData.api_keys
// Label = display name
const API_KEY_FIELDS: { key: string; label: string; placeholder: string }[] = [
  { key: 'cloudflare_account_id', label: 'Cloudflare Account ID',  placeholder: 'e.g. a1b2c3d4e5f6...' },
  { key: 'cloudflare_api_token',  label: 'Cloudflare API Token',   placeholder: 'cfk_...' },
  { key: 'deepseek',              label: 'DeepSeek API Key',        placeholder: 'sk-... (platform.deepseek.com)' },
  { key: 'openai',                label: 'OpenAI API Key',          placeholder: 'sk-...' },
  { key: 'anthropic',             label: 'Anthropic API Key',       placeholder: 'sk-ant-...' },
  { key: 'gemini',                label: 'Google Gemini API Key',   placeholder: 'AIza...' },
  { key: 'groq',                  label: 'Groq API Key',            placeholder: 'gsk_...' },
  { key: 'together',              label: 'Together AI API Key',     placeholder: 'tok-...' },
  { key: 'openrouter',            label: 'OpenRouter API Key',      placeholder: 'sk-or-...' },
  { key: 'newapi',                label: 'New-API / One-API Key',   placeholder: 'sk-...' },
  { key: 'jina',                  label: 'Jina AI API Key',         placeholder: 'jina_...' },
  // ── Image Generation (Erix Image) ─────────────────────────────────
  { key: 'eric_image_url',        label: '🎨 Erix Image — API Base URL', placeholder: 'https://image.wowerix.com/v1' },
  { key: 'eric_image_key',        label: '🎨 Erix Image — API Key',      placeholder: 'Bearer token hoặc API key' },
  { key: 'eric_image_model',      label: '🎨 Erix Image — Model ID',     placeholder: 'erix-image (mặc định)' },
];

const PROVIDERS = ['cloudflare', 'newapi', 'openai', 'anthropic', 'gemini', 'groq', 'together', 'deepseek', 'openrouter'];


export function SearchableDropdown({ options, value, onChange, placeholder, quickSelectGroups }: {
  options: { key: string; content?: string }[];
  value: string;
  onChange: (val: string) => void;
  placeholder: string;
  quickSelectGroups?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [groupFilter, setGroupFilter] = useState('');
  const [coreUnlocked, setCoreUnlocked] = useState(false);

  const cleanSearch = search.replace(/[^a-zA-Z0-9\s\u00C0-\u024F\u1E00-\u1EFF]/g, '').toLowerCase().trim();

  const isCoreKey = (k: string) => {
    return k.startsWith('v2_ceo') || k.startsWith('v2_receptionist') || 
           k.startsWith('v2_worker') || k.startsWith('v2_expert') || k === 'gateway_router' || 
           k === 'the_brain' || k.includes('lane') || k.includes('node') || 
           k.includes('embedder') || k.includes('smoother');
  };

  const filtered = options.filter(o => {
    const k = o.key.toLowerCase();
    
    // Protection filter: Hide core keys if locked
    if (quickSelectGroups && !coreUnlocked && isCoreKey(k)) return false;

    if (groupFilter) {
      if (groupFilter === 'domain_expert' && isCoreKey(k)) return false;
      if (groupFilter === 'core' && !isCoreKey(k)) return false;
      
      if (groupFilter === 'ceo' && !(k.startsWith('v2_ceo') || k === 'the_brain' || k.includes('r1'))) return false;
      if (groupFilter === 'receptionist' && !(k.startsWith('v2_receptionist') || k === 'gateway_router')) return false;
      if (groupFilter === 'worker' && !(k.startsWith('v2_worker') || k.includes('lane') || k.includes('node') || k.includes('embedder') || k.includes('smoother'))) return false;
      if (groupFilter === 'expert_core' && !k.startsWith('v2_expert')) return false;
    }

    if (!cleanSearch) return true;
    const cleanKey = o.key.replace(/[^a-zA-Z0-9\s\u00C0-\u024F\u1E00-\u1EFF]/g, '').toLowerCase();
    const cleanContent = o.content ? o.content.replace(/[^a-zA-Z0-9\s\u00C0-\u024F\u1E00-\u1EFF]/g, '').toLowerCase() : '';
    return cleanKey.includes(cleanSearch) || cleanContent.includes(cleanSearch);
  });

  const selectedKeys = value ? value.split(',').map(k => k.trim()).filter(Boolean) : [];

  const toggleKey = (k: string) => {
    if (!k) {
      onChange('');
      return;
    }
    const newKeys = selectedKeys.includes(k) ? selectedKeys.filter(x => x !== k) : [...selectedKeys, k];
    onChange(newKeys.join(','));
  };

  const toggleGroup = (grp: string) => {
    if (groupFilter === grp) setGroupFilter('');
    else setGroupFilter(grp);
    setSearch('');
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <button 
        type="button"
        onClick={() => setOpen(!open)}
        className="select"
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', textAlign: 'left', cursor: 'pointer', width: '100%', background: 'var(--bg-elevated)', minHeight: '38px', height: 'auto', padding: '6px 12px' }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', flex: 1, marginRight: '8px' }}>
          {selectedKeys.length === 0 ? (
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{placeholder}</span>
          ) : (
            selectedKeys.map(k => (
              <span key={k} style={{ background: 'rgba(168,85,247,0.2)', color: '#c084fc', padding: '2px 6px', borderRadius: '4px', fontSize: '11px' }}>{k}</span>
            ))
          )}
        </div>
        <span style={{ opacity: 0.5, fontSize: '10px' }}>▼</span>
      </button>

      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 40 }} onClick={() => setOpen(false)} />
          <div style={{
            position: 'absolute', top: '100%', left: 0, right: 0, 
            zIndex: 50, background: '#111827', 
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 'var(--radius-sm)',
            marginTop: '4px',
            boxShadow: '0 10px 25px -5px rgba(0,0,0,0.5)'
          }}>
            <div style={{ padding: '8px' }}>
              {selectedKeys.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '8px' }}>
                  {selectedKeys.map(k => (
                    <span key={k} style={{ background: 'rgba(168,85,247,0.2)', color: '#c084fc', padding: '2px 6px', borderRadius: '4px', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      {k}
                      <button type="button" onClick={(e) => { e.stopPropagation(); toggleKey(k); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '10px', padding: 0 }}>✕</button>
                    </span>
                  ))}
                </div>
              )}
              <input 
                autoFocus
                type="text"
                placeholder="Search prompt name or description..."
                value={search}
                onChange={e => { setSearch(e.target.value); setGroupFilter(''); }}
                className="input"
                style={{ width: '100%', padding: '8px', fontSize: '12px' }}
              />
            </div>
            {quickSelectGroups && (
              <div style={{ padding: '0 8px 8px 8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {/* Lĩnh vực chuyên môn */}
                <div>
                  <div style={{ fontSize: '10px', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '4px', textTransform: 'uppercase' }}>Chuyên Gia Lĩnh Vực</div>
                  <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                    <button type="button" onClick={() => toggleGroup('domain_expert')} style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', background: groupFilter === 'domain_expert' ? 'rgba(236,72,153,0.5)' : 'rgba(236,72,153,0.2)', border: '1px solid rgba(236,72,153,0.5)', color: '#f472b6', cursor: 'pointer' }}>Tất cả Chuyên Gia Mở Rộng</button>
                  </div>
                </div>

                {/* Kiến trúc lõi */}
                <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                    <div style={{ fontSize: '10px', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase' }}>
                      Kiến Trúc Lõi Hệ Thống
                    </div>
                    <button 
                      type="button" 
                      onClick={() => setCoreUnlocked(!coreUnlocked)} 
                      style={{ fontSize: '9px', background: coreUnlocked ? 'rgba(239,68,68,0.2)' : 'rgba(255,255,255,0.1)', border: 'none', color: coreUnlocked ? '#f87171' : 'var(--text-muted)', cursor: 'pointer', padding: '2px 6px', borderRadius: '4px' }}
                    >
                      {coreUnlocked ? '🔓 Đã mở khóa' : '🔒 Khóa an toàn'}
                    </button>
                  </div>
                  
                  {coreUnlocked && (
                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                      <button type="button" onClick={() => toggleGroup('core')} style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', background: groupFilter === 'core' ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'var(--text-light)', cursor: 'pointer' }}>Tất cả Core</button>
                      <button type="button" onClick={() => toggleGroup('ceo')} style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', background: groupFilter === 'ceo' ? 'rgba(245,158,11,0.5)' : 'rgba(245,158,11,0.2)', border: '1px solid rgba(245,158,11,0.5)', color: '#fcd34d', cursor: 'pointer' }}>CEO Orchestrator</button>
                      <button type="button" onClick={() => toggleGroup('receptionist')} style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', background: groupFilter === 'receptionist' ? 'rgba(16,185,129,0.5)' : 'rgba(16,185,129,0.2)', border: '1px solid rgba(16,185,129,0.5)', color: '#6ee7b7', cursor: 'pointer' }}>Lễ Tân</button>
                      <button type="button" onClick={() => toggleGroup('expert_core')} style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', background: groupFilter === 'expert_core' ? 'rgba(139,92,246,0.5)' : 'rgba(139,92,246,0.2)', border: '1px solid rgba(139,92,246,0.5)', color: '#c4b5fd', cursor: 'pointer' }}>Expert Node</button>
                      <button type="button" onClick={() => toggleGroup('worker')} style={{ fontSize: '10px', padding: '2px 6px', borderRadius: '4px', background: groupFilter === 'worker' ? 'rgba(59,130,246,0.5)' : 'rgba(59,130,246,0.2)', border: '1px solid rgba(59,130,246,0.5)', color: '#93c5fd', cursor: 'pointer' }}>Worker Bee</button>
                    </div>
                  )}
                  {!coreUnlocked && (
                    <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.3)', fontStyle: 'italic' }}>
                      Các Registry Prompt của luồng vận hành lõi đang bị khóa để tránh sửa nhầm.
                    </div>
                  )}
                </div>
              </div>
            )}
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              <div style={{ padding: '8px 12px', display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.05)', fontSize: '12px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', color: 'var(--text-light)', fontWeight: 500 }}>
                  <input 
                    type="checkbox" 
                    checked={filtered.length > 0 && filtered.every(o => selectedKeys.includes(o.key))} 
                    onChange={(e) => {
                      const isAll = e.target.checked;
                      if (isAll) {
                        const newKeys = [...selectedKeys];
                        filtered.forEach(o => { if (!newKeys.includes(o.key)) newKeys.push(o.key); });
                        onChange(newKeys.join(','));
                      } else {
                        const newKeys = selectedKeys.filter(k => !filtered.find(o => o.key === k));
                        onChange(newKeys.join(','));
                      }
                    }} 
                    style={{ accentColor: '#a855f7', width: '12px', height: '12px', cursor: 'pointer' }} 
                  />
                  Select All
                </label>
              </div>
              <div 
                style={{ padding: '8px 12px', fontSize: '12px', cursor: 'pointer', background: selectedKeys.length === 0 ? 'rgba(168,85,247,0.15)' : 'transparent', color: selectedKeys.length === 0 ? '#c084fc' : 'var(--text-light)', display: 'flex', justifyContent: 'space-between' }}
                onClick={() => { toggleKey(''); setOpen(false); setSearch(''); setGroupFilter(''); }}
              >
                <span>-- Dynamic / None --</span>
                {selectedKeys.length === 0 && <span>✓</span>}
              </div>
              {filtered.map(o => {
                const desc = o.content ? o.content.split('\n')[0].replace(/^\[.*?\]\s*/, '') : '';
                const isSelected = selectedKeys.includes(o.key);
                return (
                  <div 
                    key={o.key}
                    style={{ 
                      padding: '8px 12px', 
                      cursor: 'pointer', 
                      background: isSelected ? 'rgba(168,85,247,0.15)' : 'transparent',
                      borderTop: '1px solid rgba(255,255,255,0.04)',
                    }}
                    onClick={(e) => { e.stopPropagation(); toggleKey(o.key); }}
                    onMouseEnter={e => {
                      if (!isSelected) e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.background = isSelected ? 'rgba(168,85,247,0.15)' : 'transparent';
                    }}
                  >
                    <div style={{ fontSize: '12px', color: isSelected ? '#c084fc' : 'var(--text-light)', fontWeight: 500, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="checkbox" checked={isSelected} readOnly style={{ accentColor: '#a855f7', width: '12px', height: '12px', cursor: 'pointer' }} />
                        <span>{o.key}</span>
                      </div>
                    </div>
                    {desc && <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '4px', marginLeft: '20px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{desc}</div>}
                  </div>
                )
              })}
              {filtered.length === 0 && <div style={{ padding: '8px 12px', fontSize: '12px', color: 'var(--text-muted)' }}>No matches found</div>}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export function NodesPage() {
  const [selected, setSelected] = useState(ALL_NODES[0]!.role);
  const [promptData, setPromptData] = useState<any>(null);
  const [chainData, setChainData] = useState<any>(null);
  const [registry, setRegistry] = useState<any>(null);
  const [editedPrompt, setEditedPrompt] = useState('');
  const [saving, setSaving] = useState(false);
  const [loadError, setLoadError] = useState('');
  const [msg, setMsg] = useState('');
  const [chain, setChain] = useState<any[]>([]);

  // Swarm V2 Specific Config
  const [defaultSwitch, setDefaultSwitch] = useState<string>('');
  const [defaultRegistry, setDefaultRegistry] = useState<string>('');
  const [allSwitchPrompts, setAllSwitchPrompts] = useState<{key: string}[]>([]);
  const [allRegistryPrompts, setAllRegistryPrompts] = useState<{key: string}[]>([]);
  const node = ALL_NODES.find(n => n.role === selected)!;

  useEffect(() => {
    setPromptData(null);
    setChainData(null);
    setLoadError('');
    setMsg('');

    Promise.all([
      api.getPrompt(selected),
      api.getProviderConfig(),
      api.getModelRegistry(),
    ]).then(([p, c, r]) => {
      setPromptData(p);
      setEditedPrompt(p.prompt ?? '');
      setChainData(c);
      setRegistry(r.registry);
      
      const nodeConfig = c.nodes?.[selected];
      const isGeminiDefault = ['image_to_text', 'node_llama_noise_filter', 'node_llama_history_trimmer'].includes(selected);
      const defaultProvider = isGeminiDefault ? 'gemini' : 'cloudflare';
      const defaultModel = r.registry?.[selected]?.equivalents?.[defaultProvider] ?? r.registry?.[selected]?.cf_model ?? '';
      const nodeChain = nodeConfig?.chain ?? [
        { provider: defaultProvider, model: defaultModel, enabled: true, priority: 0 }
      ];
      setChain(nodeChain);
      setDefaultSwitch(nodeConfig?.default_switch ?? '');
      setDefaultRegistry(nodeConfig?.default_registry ?? '');

      // Load prompts if it's a V2 node
      if (selected.startsWith('v2_')) {
        api.v2ListSwitchPrompts().then(res => setAllSwitchPrompts(res.items || []));
        api.v2ListRegistryPrompts().then(res => setAllRegistryPrompts(res.items || []));
      }
    }).catch((err) => {
      // Show error instead of silently spinning forever
      setLoadError(String(err));
      // Set dummy data so spinner stops
      setPromptData({ prompt: '', is_custom: false });
    });
  }, [selected]);

  const flash = (text: string) => {
    setMsg(text);
    setTimeout(() => setMsg(''), 3000);
  };

  const savePrompt = async () => {
    setSaving(true);
    try {
      await api.updatePrompt(selected, editedPrompt);
      flash('✓ Prompt saved');
    } catch (e) {
      flash('✗ ' + String(e));
    } finally {
      setSaving(false);
    }
  };

  const resetPrompt = async () => {
    if (!confirm('Reset to default prompt?')) return;
    try {
      await api.resetPrompt(selected);
      const p = await api.getPrompt(selected);
      setEditedPrompt(p.prompt);
      flash('✓ Reset to default');
    } catch (e) {
      flash('✗ ' + String(e));
    }
  };

  const saveChain = async () => {
    setSaving(true);
    try {
      await api.updateNodeChain(selected, chain, defaultSwitch, defaultRegistry);
      flash('✓ Provider chain saved');
    } catch (e) {
      flash('✗ ' + String(e));
    } finally {
      setSaving(false);
    }
  };

  const saveApiKeys = async () => {
    setSaving(true);
    try {
      await api.updateGlobalApiKeys(chainData.api_keys || {});
      flash('✓ Global API keys saved');
    } catch (e) {
      flash('✗ ' + String(e));
    } finally {
      setSaving(false);
    }
  };

  const saveSwitchPromptSettings = async () => {
    setSaving(true);
    try {
      await api.updateSwitchPromptSettings(chainData.switch_prompt_settings || { enable_checkpoints: true, enable_lenses: true });
      flash('✓ Switch Prompt settings saved');
    } catch (e) {
      flash('✗ ' + String(e));
    } finally {
      setSaving(false);
    }
  };

  const addProvider = () => {
    setChain(c => [...c, { provider: 'deepseek', model: 'deepseek-reasoner', enabled: true, priority: c.length }]);
  };

  const removeProvider = (i: number) => setChain(c => c.filter((_, idx) => idx !== i));

  const updateChainItem = (i: number, key: string, value: any) => {
    setChain(c => c.map((item, idx) => {
      if (idx !== i) return item;
      const updated = { ...item, [key]: value };
      // Auto-fill model from registry when provider changes
      if (key === 'provider' && registry?.[selected]) {
        updated.model = registry[selected].equivalents?.[value] ?? '';
      }
      return updated;
    }));
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">AI Nodes</h1>
          <p className="page-subtitle">Configure providers, models, and system prompts per node</p>
        </div>
        {msg && <span style={{ fontSize: '13px', color: msg.startsWith('✓') ? 'var(--accent-green)' : 'var(--accent-red)' }}>{msg}</span>}
      </div>

      {/* Node selector V1 */}
      <h2 style={{ fontSize: '18px', marginBottom: '12px', color: 'var(--text-light)' }}>Node Agent Swarm Version 1</h2>
      <div className="node-grid" style={{ marginBottom: '28px' }}>
        {NODES_V1.map(n => (
          <div
            key={n.role}
            className={`node-card ${selected === n.role ? 'selected' : ''}`}
            onClick={() => setSelected(n.role)}
          >
            <div className="node-card__header">
              <div className="node-card__icon">{n.icon}</div>
              <div>
                <div className="node-card__name">{n.name}</div>
                <div className="node-card__model">{n.role}</div>
              </div>
            </div>
            <p className="node-card__desc">{n.desc}</p>
          </div>
        ))}
      </div>

      {/* Node selector V2 */}
      <h2 style={{ fontSize: '18px', marginBottom: '12px', color: 'var(--text-light)' }}>Node Agent Swarm Version 2</h2>
      <div className="node-grid" style={{ marginBottom: '28px' }}>
        {NODES_V2.map(n => (
          <div
            key={n.role}
            className={`node-card ${selected === n.role ? 'selected' : ''}`}
            onClick={() => setSelected(n.role)}
            style={{ borderColor: selected === n.role ? 'var(--accent-purple)' : 'rgba(168, 85, 247, 0.2)' }}
          >
            <div className="node-card__header">
              <div className="node-card__icon">{n.icon}</div>
              <div>
                <div className="node-card__name">{n.name}</div>
                <div className="node-card__model">{n.role}</div>
              </div>
            </div>
            <p className="node-card__desc">{n.desc}</p>
          </div>
        ))}
      </div>

      {/* Node selector Image & Vision */}
      <h2 style={{ fontSize: '18px', marginBottom: '12px', color: 'var(--text-light)' }}>Media Processing Nodes (Vision & Art)</h2>
      <div className="node-grid" style={{ marginBottom: '28px' }}>
        {NODES_IMAGE.map(n => (
          <div
            key={n.role}
            className={`node-card ${selected === n.role ? 'selected' : ''}`}
            onClick={() => setSelected(n.role)}
            style={{ borderColor: selected === n.role ? '#fbbf24' : 'rgba(251, 191, 36, 0.2)' }}
          >
            <div className="node-card__header">
              <div className="node-card__icon">{n.icon}</div>
              <div>
                <div className="node-card__name">{n.name}</div>
                <div className="node-card__model">{n.role}</div>
              </div>
            </div>
            <p className="node-card__desc">{n.desc}</p>
          </div>
        ))}
      </div>

      {/* Load error banner */}
      {loadError && (
        <div style={{
          padding: '12px 16px', marginBottom: '16px',
          background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
          borderRadius: '8px', color: '#f87171', fontSize: '12px',
        }}>
          ⚠ Failed to load node config: {loadError}
          <button
            onClick={() => { setLoadError(''); setSelected(s => s); }}
            style={{ marginLeft: '12px', fontSize: '11px', padding: '2px 8px', cursor: 'pointer',
              background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: '4px', color: '#f87171' }}
          >Retry</button>
        </div>
      )}

      {!promptData ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><div className="spinner" /></div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', position: 'relative', zIndex: 10 }}>

          {/* Provider Chain */}
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <div className="card__title" style={{ margin: 0 }}>Provider Chain</div>
              <button className="btn btn--secondary btn--sm" onClick={addProvider}>+ Add</button>
            </div>

            {chain.map((item, i) => (
              <div key={i} className="chain-item">
                <div className="chain-item__priority">{i}</div>
                <div style={{ flex: 1 }}>
                  <select
                    className="select"
                    style={{ marginBottom: '6px' }}
                    value={item.provider}
                    onChange={e => updateChainItem(i, 'provider', e.target.value)}
                  >
                    {PROVIDERS.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                  <input
                    className="input"
                    placeholder="model name..."
                    value={item.model}
                    onChange={e => updateChainItem(i, 'model', e.target.value)}
                    style={{ fontFamily: 'var(--font-mono)', fontSize: '12px' }}
                  />
                  {(item.provider === 'newapi') && (
                    <input
                      className="input"
                      placeholder="base_url (e.g. https://api.example.com/v1)"
                      value={item.base_url ?? ''}
                      onChange={e => updateChainItem(i, 'base_url', e.target.value)}
                      style={{ marginTop: '6px', fontSize: '12px' }}
                    />
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', fontSize: '12px', color: 'var(--text-secondary)' }}>
                    <input type="checkbox" checked={item.enabled} onChange={e => updateChainItem(i, 'enabled', e.target.checked)} />
                    on
                  </label>
                  <button className="btn btn--danger btn--sm" onClick={() => removeProvider(i)} title="Remove">✕</button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: '12px' }}>
              {selected.startsWith('v2_') && (
                <div style={{ padding: '12px', background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '8px', marginBottom: '16px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 600, color: '#60a5fa', marginBottom: '8px' }}>Swarm V2 Prompts</div>
                  
                  <div style={{ marginBottom: '8px' }}>
                    <label style={{ display: 'block', fontSize: '11px', color: 'var(--text-muted)', marginBottom: '4px' }}>Default Switch Prompt (Kim chỉ nam)</label>
                    <SearchableDropdown
                      options={allSwitchPrompts}
                      value={defaultSwitch}
                      onChange={setDefaultSwitch}
                      placeholder="-- Dynamic / None --"
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', fontSize: '11px', color: 'var(--text-muted)', marginBottom: '4px' }}>Default Registry Prompt (Chức năng chuyên gia)</label>
                    <SearchableDropdown
                      options={allRegistryPrompts}
                      value={defaultRegistry}
                      onChange={setDefaultRegistry}
                      placeholder="-- Dynamic / None --"
                      quickSelectGroups={true}
                    />
                  </div>
                </div>
              )}

              <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginBottom: '8px' }}>
                Priority 0 = primary. Auto-fallback to next if primary fails.
              </div>
              <button className="btn btn--primary w-full" onClick={saveChain} disabled={saving} style={{ justifyContent: 'center' }}>
                {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : 'Save Provider Chain'}
              </button>
            </div>

            {/* Model equivalents reference */}
            {registry?.[selected] && (
              <div style={{ marginTop: '16px', padding: '12px', background: 'var(--bg-elevated)', borderRadius: 'var(--radius-sm)' }}>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginBottom: '8px' }}>Suggested models for {node.name}</div>
                {Object.entries(registry[selected].equivalents as Record<string, string>).map(([prov, model]) => (
                  <div key={prov} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', padding: '3px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                    <span style={{ color: prov === 'deepseek' ? '#a78bfa' : 'var(--text-muted)', fontWeight: prov === 'deepseek' ? 700 : 400 }}>{prov}</span>
                    <code style={{ fontFamily: 'var(--font-mono)', color: prov === 'deepseek' ? '#c4b5fd' : '#a78bfa', fontSize: '10px' }}>{model}</code>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* System Prompt */}
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span className="card__title" style={{ margin: 0 }}>System Prompt</span>
                {promptData.is_custom && <span className="badge badge--amber">custom</span>}
              </div>
              <div style={{ display: 'flex', gap: '6px' }}>
                <button className="btn btn--secondary btn--sm" onClick={resetPrompt}>Reset</button>
                <button className="btn btn--primary btn--sm" onClick={savePrompt} disabled={saving}>
                  {saving ? <span className="spinner" style={{ width: 12, height: 12 }} /> : 'Save'}
                </button>
              </div>
            </div>
            <textarea
              className="textarea"
              style={{ minHeight: '420px', fontSize: '12px' }}
              value={editedPrompt}
              onChange={e => setEditedPrompt(e.target.value)}
              spellCheck={false}
            />
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '8px' }}>
              {editedPrompt.length} chars · ~{Math.ceil(editedPrompt.length / 4)} tokens
            </div>
          </div>
        </div>
      )}

      {/* Global API Keys Section */}
      {chainData && (
        <div className="card" style={{ marginTop: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div>
              <div className="card__title" style={{ margin: 0 }}>Global API Keys</div>
              <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '4px' }}>
                Stored securely in KV. Override env variables. Enter DeepSeek key to use deepseek-reasoner (R1).
              </div>
            </div>
            <button className="btn btn--primary btn--sm" onClick={saveApiKeys} disabled={saving}>
              {saving ? <span className="spinner" style={{ width: 12, height: 12 }} /> : 'Save Keys'}
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            {API_KEY_FIELDS.map(({ key, label, placeholder }) => (
              <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <label style={{
                  fontSize: '12px', fontWeight: 600,
                  color: key === 'deepseek' ? '#c4b5fd' : 'var(--text-secondary)',
                }}>
                  {key === 'deepseek' && '⭐ '}{label}
                </label>
                <input
                  type="password"
                  className="input"
                  placeholder={placeholder}
                  value={chainData.api_keys?.[key] ?? ''}
                  onChange={e => {
                    setChainData((prev: any) => ({
                      ...prev,
                      api_keys: { ...(prev.api_keys || {}), [key]: e.target.value }
                    }));
                  }}
                  style={{
                    fontSize: '12px', fontFamily: 'var(--font-mono)',
                    borderColor: key === 'deepseek' ? 'rgba(167,139,250,0.3)' : undefined,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Swarm V1 Cognitive Switch Prompt Settings */}
      {chainData && (
        <div className="card" style={{ marginTop: '20px', borderColor: 'rgba(236,72,153,0.3)', background: 'linear-gradient(180deg, rgba(236,72,153,0.05) 0%, transparent 100%)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div>
              <div className="card__title" style={{ margin: 0, color: '#f472b6' }}>🧠 Cognitive Switch Prompt Settings (Swarm V1)</div>
              <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '4px' }}>
                Bộ Tắt/Bật Hệ tư duy triết học (Kim chỉ nam) dành riêng cho các Node V1 (Core Reasoner, The Brain, Lane 4 Agent).
              </div>
            </div>
            <button className="btn btn--primary btn--sm" onClick={saveSwitchPromptSettings} disabled={saving} style={{ background: '#ec4899', borderColor: '#ec4899' }}>
              {saving ? <span className="spinner" style={{ width: 12, height: 12 }} /> : 'Save Toggles'}
            </button>
          </div>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '12px', background: 'rgba(0,0,0,0.2)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.05)' }}>
              <input
                type="checkbox"
                checked={chainData.switch_prompt_settings?.enable_checkpoints ?? true}
                onChange={e => {
                  setChainData((prev: any) => ({
                    ...prev,
                    switch_prompt_settings: {
                      ...(prev.switch_prompt_settings || { enable_lenses: true }),
                      enable_checkpoints: e.target.checked
                    }
                  }));
                }}
                style={{ width: '16px', height: '16px', accentColor: '#ec4899' }}
              />
              <div>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#fbcfe8' }}>ON/OFF 3 CHECKPOINT</div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Cảnh báo an toàn & Logic vòng lặp (Tránh lan man)</div>
              </div>
            </label>

            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '12px', background: 'rgba(0,0,0,0.2)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.05)' }}>
              <input
                type="checkbox"
                checked={chainData.switch_prompt_settings?.enable_lenses ?? true}
                onChange={e => {
                  setChainData((prev: any) => ({
                    ...prev,
                    switch_prompt_settings: {
                      ...(prev.switch_prompt_settings || { enable_checkpoints: true }),
                      enable_lenses: e.target.checked
                    }
                  }));
                }}
                style={{ width: '16px', height: '16px', accentColor: '#ec4899' }}
              />
              <div>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#fbcfe8' }}>ON/OFF 7 LENSES OF THINKING</div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Hệ tư duy triết học sâu (Dành cho Qwen/LLaMA mô phỏng IQ 120B)</div>
              </div>
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
